import PropTypes from 'prop-types';
import ExpiryDateField from '../../../../../v2/form/ExpiryDateField';
import ExpiryInputField from '../../../../../v2/form/ExpiryInputField';
import InputField from '../../../../../v2/form/InputField';
import camelcaseToKebabcase from '../../../../../v2/utils/camelcase-to-kebabcase';

function NewCardFormFieldSet(props) {
  const legacyNames = (prefix, field) => {
    const kebabName = camelcaseToKebabcase(field.name);
    const nameInClass = field.nameInClass ? field.nameInClass : ` ${kebabName}-field`;
    const id = field.id ? field.id : `${kebabName}-fields`;
    
    return {
      id,
      nameInClass: ` ${nameInClass}`,
      nameOnForm: `${prefix}.${field.name}`,
    };
  };
  
  const fieldNamePrefix = 'paymentCard';
  
  // eslint-disable-next-line array-callback-return
  return props.definedFields.map((definedField) => {
    if (definedField !== null) {
      const key = definedField.key || `${fieldNamePrefix}--${definedField.name}`;
  
      const cardFieldAttributes = {
        key,
        fieldContainer: props.fieldContainer,
        legacyNames: legacyNames(fieldNamePrefix, definedField),
        fieldNamePrefix,
        value: props.newCardDetails[definedField.name],
        definedField,
      };
  
      // retrieve card icons for credit card number field
      if (definedField.name === 'creditCardNumber' && cardFieldAttributes.value?.length >= 6) {
        cardFieldAttributes.icon = props.cardType.icon;
        cardFieldAttributes.iconName = props.cardType.iconName;
      }
  
      if (definedField.name === 'expiryDate') {
        return (props.shouldUseExpiryInputField)
          ? (
            <ExpiryInputField
              {...cardFieldAttributes}
            />
          )
          : (
            <ExpiryDateField
              {...cardFieldAttributes}
            />
          );
      }
  
      return (
        <InputField
          {...cardFieldAttributes}
        />
      );
    }
  });
}

NewCardFormFieldSet.propTypes = {
  definedFields: PropTypes.array.isRequired,
  newCardDetails: PropTypes.object.isRequired,
  fieldContainer: PropTypes.object.isRequired,
  cardType: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
};

export default NewCardFormFieldSet;
